import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, allowedRoles = null }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="loading"></div>
        <span className="ml-2">Carregando...</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Se não há roles específicos requeridos, qualquer usuário autenticado pode acessar
  if (!allowedRoles) {
    return children;
  }

  // Verificar se o usuário tem uma das roles permitidas
  const hasPermission = Array.isArray(allowedRoles) 
    ? allowedRoles.includes(user.role)
    : user.role === allowedRoles;

  if (!hasPermission) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="card max-w-md w-full">
          <div className="card-body text-center">
            <h2 className="text-xl font-semibold text-danger mb-4">
              Acesso Negado
            </h2>
            <p className="text-secondary mb-4">
              Você não tem permissão para acessar esta página.
            </p>
            <p className="text-sm text-muted">
              Seu perfil atual: <strong>{user.role}</strong>
            </p>
            <p className="text-sm text-muted">
              Perfis necessários: <strong>{Array.isArray(allowedRoles) ? allowedRoles.join(', ') : allowedRoles}</strong>
            </p>
            <button 
              onClick={() => window.history.back()}
              className="btn btn-primary mt-4"
            >
              Voltar
            </button>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;